import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const statusToastClass =
  "[&_[data-description]]:text-inherit [&_[data-description]]:opacity-90 [&_[data-icon]]:text-inherit"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast border border-transparent shadow-lg group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border",
          description: "group-[.toast]:text-muted-foreground",
          success: `!bg-success !text-success-foreground !border-success ${statusToastClass}`,
          warning: `!bg-warning !text-warning-foreground !border-warning ${statusToastClass}`,
          error: `!bg-error !text-error-foreground !border-error ${statusToastClass}`,
          info: `!bg-info !text-info-foreground !border-info ${statusToastClass}`,
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
